export const CONTEST_BASE_ROUTE = 'contests/:id';

export const CONTEST_TAB_ROUTES = {
    'home': 'home',
    'lessons': 'lessons',
    'manage': 'manage',
    'ranking': 'ranking'
};